import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DanhMucThietBi } from 'src/app/shared/DanhMucThietBi.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class DanhMucThietBiService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.controller = "DanhMucThietBi";
    }
}

